import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { loadState, saveState } from './index';

// Define a type for the slice state
export interface ToolState {
    diameter: number;
    flutes: number;
    cutLength: number;
    coating: boolean;
    toolPath: string;
    type: 'endmill'|'drill'|'';
    helixAngle: number;
	geometry: number;

    toolStickout: number;
    depthOfCut: number;
    widthOfCut: number;
    widthOfSlot: number;
    depthOfHole: number;

    edp: number;
    name: string;
    series: string;

    speedFinetuning: number;
    feedFinetuning: number;
}

const placeholderState = {
    diameter: 0,
    flutes: 0,
    cutLength: 0,
    coating: false,
    toolPath: 'hem',
    type: '',
    helixAngle: 0,
	geometry: 0,

    toolStickout: 0,
    depthOfCut: 0,
    widthOfCut: 0,
    widthOfSlot: 0,
    depthOfHole: 0,

    edp: 0,
    name: '',
    series: '',

    speedFinetuning: 1,
    feedFinetuning: 1
}

// Define the initial state using that type
const initialState: ToolState = loadState('tool', placeholderState);

export const counterSlice = createSlice({
    name: 'tool',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        set(state, action: PayloadAction<ToolState>) {
            Object.keys(action.payload).forEach(key => {
                // @ts-ignore
                state[key] = action.payload[key];
            })
            saveState('tool', state);
        },
        reset: (state) => {
            Object.keys(placeholderState).forEach(key => {
                // @ts-ignore
                state[key] = placeholderState[key];
            })
            saveState('tool', state);
        },
        setToolType: (state, action:PayloadAction<'endmill'|'drill'>) => {
            state.type = action.payload;
            saveState('tool', state);
        },
        setDiameter: (state, action: PayloadAction<number>) => {
            state.diameter = action.payload;
            saveState('tool', state);
        },
        setFlutes: (state, action: PayloadAction<number>) => {
            state.flutes = action.payload;
            saveState('tool', state);
        },
        setCutLength: (state, action: PayloadAction<number>) => {
            state.cutLength = action.payload;
            saveState('tool', state);
        },
        setCoated: (state, action: PayloadAction<boolean>) => {
            state.coating = action.payload;
            saveState('tool', state);
        },
        finetuneSpeed: (state, action: PayloadAction<number>) => {
            state.speedFinetuning = action.payload;
            saveState('tool', state);
        },
        finetuneFeed: (state, action: PayloadAction<number>) => {
            state.feedFinetuning = action.payload;
            saveState('tool', state);
        }
    },
})

export const { set, reset, setToolType, setDiameter, setFlutes, setCutLength, setCoated, finetuneSpeed, finetuneFeed } = counterSlice.actions;

export default counterSlice.reducer
